import { AfterViewInit, Component, ViewChild, OnInit } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { TemplateService } from '../../shared/services/template.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-template-solution-list',
  templateUrl: './template-solution-list.component.html',
  styleUrls: ['./template-solution-list.component.css']
})
export class TemplateSolutionListComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = [];
  dataSource = new MatTableDataSource<any>([]);
  selectedTemplateType: string = '';
  fileName: any = ""

  // Configuration object for different templates
  templateConfigurations: { [key: string]: string[] } = {
    'survey': ['Program', 'SolutionName', 'startDate', 'endDate', 'deeplink'],
    'improvementProject': ['Program', 'SolutionName', 'startDate', 'endDate', 'deeplink'],
    'observation without rubrics': ['Program', 'SolutionName', 'startDate', 'endDate', 'deeplink'],
    'observation with rubrics': ['Program', 'SolutionName', 'startDate', 'endDate', 'deeplink']
  };

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    private templateService: TemplateService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private location: Location
  ) {
  }

  ngOnInit(): void {
    this.route.queryParams
      .subscribe(params => {
        this.fileName = params['fileName'];
        console.log(this.fileName,"line no 40")
      });
    this.selectedTemplateType = this.getTemplateType(this.fileName);
    this.displayedColumns = this.templateConfigurations[this.selectedTemplateType] || [];
    this.loadSolutions();
  }
  

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  loadSolutions(): void {
    const resourceType = this.getResourceType(this.fileName);
    const extension = this.getExtension(this.fileName);
  
    this.templateService.getSurveySolutions(resourceType, extension).subscribe(
      (response: any) => {
        if (response.status === 200 && response.code === 'Success') {
          // Determine base URL once
          const baseurl = this.templateService.getBaseURL();
  
          // Map response data into the table structure
          this.dataSource.data = response.csvPath.map((item: any) => {
            // Determine `crationtype` based on resourceType
            let crationtype = '';
            if (resourceType === 'improvementProject') {
              crationtype = 'manage-learn/create-project/';
            } else if (resourceType === 'survey') {
              crationtype = 'manage-learn/take-survey/';
            } else if (
              resourceType === 'observation without rubrics') {
              crationtype = 'manage-learn/create-observation/';
            } else if (resourceType === 'observation with rubrics'){
              crationtype = 'manage-learn/create-observation/';
            }
            // Construct deeplink
            const deeplink = `${baseurl}${crationtype}${item.Link || ''}`;
            // Return the row object
            return {
              Program: item.PROGRAM_NAME,
              SolutionName: item.SOLUTION_NAME,
              startDate: item.START_DATE,
              endDate: item.END_DATE,
              deeplink: deeplink
            };
          });
  
          console.log(this.dataSource.data, 'Processed table data');
        } else {
          this.toastr.error('Failed to load solutions');
        }
      },
      (error: any) => {
        console.error('Error fetching solutions:', error);
        this.toastr.error('An error occurred while fetching solutions');
      }
    );
  }
  
  // Copy Deeplink Method
  copyLink(deeplink: string): void {
    if (!deeplink) {
      this.toastr.error('Deeplink is missing');
      return;
    }
    console.log('Deeplink to copy:', deeplink); // Debugging the deeplink
    navigator.clipboard.writeText(deeplink).then(
      () => this.toastr.success('Link copied to clipboard!'),
      () => this.toastr.error('Failed to copy link')
    );
  }

  getTemplateType(templateType: string): string {
    // Implement logic to determine the selected template type
    switch (templateType) {
      case 'survey': return 'survey';
      case 'improvementProject': return 'improvementProject';
      case 'observation without rubrics': return 'observation without rubrics';
      case 'observation with rubrics': return 'observation with rubrics';
      default: return 'unknown';
    } // Example return value, replace with actual logic
  }

  getResourceType(templateType: string): string {
    console.log(templateType,"line no 99");
    
    switch (templateType) {
      case 'survey': return 'survey';
      case 'improvementProject': return 'improvementProject';
      case 'observation without rubrics': return 'observation without rubrics';
      case 'observation with rubrics': return 'observation with rubrics';
      default: return 'unknown';
    }
  }

  getExtension(templateType: string): string {
    console.log(templateType,"line no 115");
    
    switch (templateType) {
      case 'survey': return 'getSolutions';
      case 'improvementProject': return 'getSolutions';
      case 'observation without rubrics': return 'getSolutions';
      case 'observation with rubrics': return 'getSolutions';
      default: return 'default-extension';
    }
  }

  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  goBack() {
    this.location.back();
  }
}
